import './SideHint.css';

import React from 'react';

export default class SideHint extends React.Component {
  render() {
    const {
      behavior,
    } = this.props;

    return (
      <div className={`SideHint ${behavior}`}>
        <span className="highlight">{behavior === 'positive' ? "Positive" : "Negative"}</span> behaviour
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/rlgl/SideHint/index.js